module.exports = __webpack_public_path__ + "static/media/Executive_Committee_Minutes_5_28_26.e9f460a4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/26-27/Executive_Committee_Minutes_5_28_26.pdf
// module id = 259
// module chunks = 0